/* global getScript */
define('meetrics',[],function() {
    'use strict';

    // Anti fraud script
    function loadMeetrics() {
        var random = Math.floor(Math.random() * 1e6);
        getScript('https://s372.meetrics.net/bb-mx/prime/mtrcs_164235.js?pjid=164235&cb=' + random + '&size=all');
    }

    return loadMeetrics;
});

